import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAccountingCustomSegments, useAccountingOptions } from '../../../../hooks';
import {customSegmentLevelTypeConstants} from '../../../../constants';

export const useJournalEntryTabState = (onFilter, initialSearch = '') => {
  const [query, setQuery] = useState({ search: initialSearch });

  const { expenseCategoryOptions, locationOptions } = useAccountingOptions();

  const customSegments = useAccountingCustomSegments({levelsPropertyName: customSegmentLevelTypeConstants.JE});

  const employees = useSelector(state => state?.company?.employees || []);

  const handleOnFilter = (filterParams) => {
    setQuery(prev => ({ ...prev, ...filterParams }));
    onFilter?.(filterParams);
  };

  return {
    customSegments,
    employees,
    expenseCategoryOptions,
    locationOptions,
    handleOnFilter,
    setQuery,
    query,
  };
}

